import React from "react";
import styles from "./FaceToFaceSection.module.css";
import faceImage from "../images/fullprofile.svg";

const FaceToFace = () => {
  return (
    <section className={` row g-0 ${styles.faceSection}`}>
      <div className={`col-lg-6  ${styles.imageContainer}`}>
        <img
          src={faceImage}
          alt="Face-to-Face Communication"
          className={styles.faceImage}
        />
      </div>
      <div className={`col-lg-5  ${styles.textContent}`}>
        <h2>
          Connect <span className={styles.highlight}>face-to-face</span> with{" "}
          <br className={styles.hideOnSmall}/> your customers through live <br className={styles.hideOnSmall}/> video chat
        </h2>
        <p>
          Connect with your customers through live video chat and have real-time
          <br className={styles.hideOnSmall} />
          face-to-face conversations from anywhere in the world. Build stronger{" "}
          <br className={styles.hideOnSmall} />
          relationships and offer an interactive customer service experience
          without the  need for physical meetings.
        </p>
      </div>
    </section>
  );
};

export default FaceToFace;
